import React from 'react';
import { Card, Col, Row, Tag } from 'antd';
import { ClockCircleOutlined, ArrowRightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const TaskWidget = ({ title, task, onClick, cancelTask }) => {
  const customCardHead = {
    background: '#f0f0f0'
    /* Otros estilos */
  };

  return (
    <Card
      headStyle={customCardHead}
      onClick={() => onClick && onClick(task)}
      hoverable
      title={title || 'Tarea'}
      extra={cancelTask && <a onClick={(e) => {
        e.stopPropagation();
        cancelTask(task?.nombre);
      }}>Cancelar</a>}
    >
      <Row>
        <Col gutter={16}>
          <ClockCircleOutlined style={{ marginRight: 8 }} />
          {task?.fecha_alta}
        </Col>
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={11}>
          <b>{task?.unidad_origen}</b>
          <p><Tag color="blue">{task?.origen}</Tag></p>
        </Col>
        <Col className="gutter-row" style={{ textAlign: 'right' }} span={2}>
          <ArrowRightOutlined />
        </Col>
        <Col className="gutter-row" style={{ textAlign: 'right' }} span={11}>
          <b>{task?.ctrl_destino}</b>
          <p>
            <Tag color={'green'} style={{ marginRight: 0 }}>
              {task?.destino}
            </Tag>
          </p>
        </Col>
      </Row>
    </Card>
  );
};

TaskWidget.propTypes = {
  title: PropTypes.string,
  task: PropTypes.object,
  onClick: PropTypes.func,
  cancelTask: PropTypes.func
};

export default TaskWidget;
